import React, { useState, useRef } from 'react';
import { Form, Button, Icon, Dropdown } from 'semantic-ui-react';
import './MessageComposer.css';

const MessageComposer = ({
  onSendMessage,
  disabled = false,
  placeholder = "Type a message...",
  threadContext = null
}) => {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('GENERAL');
  const textAreaRef = useRef(null);

  const messageTypeOptions = [
    { key: 'GENERAL', value: 'GENERAL', text: 'General Message', icon: 'comment' },
    { key: 'OPPORTUNITY_INQUIRY', value: 'OPPORTUNITY_INQUIRY', text: 'Opportunity Inquiry', icon: 'briefcase' },
    { key: 'APPLICATION_RESPONSE', value: 'APPLICATION_RESPONSE', text: 'Application Response', icon: 'file alternate' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim() || disabled) return;

    onSendMessage(message, messageType);
    setMessage('');
    setMessageType('GENERAL');

    // Reset textarea height
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleTextAreaChange = (e) => {
    setMessage(e.target.value);

    // Auto-resize textarea
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px';
    }
  };

  const getContextualMessageType = () => {
    if (threadContext?.startsWith('opportunity_')) {
      return 'OPPORTUNITY_INQUIRY';
    } else if (threadContext?.startsWith('application_')) {
      return 'APPLICATION_RESPONSE';
    }
    return 'GENERAL';
  };

  // Auto-set message type based on thread context
  React.useEffect(() => {
    const contextualType = getContextualMessageType();
    if (contextualType !== 'GENERAL') {
      setMessageType(contextualType);
    }
  }, [threadContext]);

  return (
    <div className="message-composer">
      <Form onSubmit={handleSubmit} className="composer-form">
        <div className="composer-header">
          <Dropdown
            selection
            compact
            options={messageTypeOptions}
            value={messageType}
            onChange={(e, { value }) => setMessageType(value)}
            className="message-type-selector"
          />
        </div>

        <div className="composer-input">
          <Form.TextArea
            ref={textAreaRef}
            value={message}
            onChange={handleTextAreaChange}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            disabled={disabled}
            className="message-input"
            rows={1}
            style={{
              minHeight: '40px',
              maxHeight: '120px',
              resize: 'none',
              overflow: 'hidden'
            }}
          />

          <Button
            type="submit"
            primary
            disabled={disabled || !message.trim()}
            loading={disabled}
            className="send-button"
            icon
          >
            <Icon name="send" />
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default MessageComposer;
